import { PropType } from 'vue'
import { Subtask } from '@/api/pathways/subtasks/types'

export type PointerSubtaskDisplayData = Subtask & {
  textReceivedStr: string
  memberName: string
}

export const textingNotificationsModalProps = {
  subtasks: {
    type: Object as PropType<PointerSubtaskDisplayData[]>,
    required: true,
  },
  isOpen: { type: Boolean, required: true },
  totalPointerSubtasks: { type: Number, required: true },
}
